import type { FeedbackMessages } from './en';

const es: FeedbackMessages = {
  qualified: {
    title: '¡Gracias por completar este estudio!',
    body1: 'Ya puede cerrar la ventana del navegador.',
    body2: 'Esperamos volver a verlo pronto.',
    refCode: 'Código de referencia: {code}',
  },
  quotaFull: {
    title: 'Este estudio está cerrado',
    body1: 'Gracias por su interés en nuestro estudio.',
    body2: 'Lamentablemente, ya hemos recibido todas las respuestas que necesitábamos.',
    body3: '¡Esperamos contar con usted en uno de nuestros futuros estudios!',
    refCode: 'Código de referencia: {code}',
  },
  terminated: {
    title: '¡Gracias por compartir sus comentarios!',
    body1:
      'Esperamos contar con usted próximamente en nuestros futuros estudios. Mientras tanto, le deseamos un excelente día.',
    body2: 'Por favor, cierre esta ventana del navegador.',
    refCode: 'Código de referencia: {code}',
  },
  mismatch: {
    title: 'Gracias por su interés',
    body1: 'Lamentablemente, usted no forma parte del grupo objetivo de este estudio en particular.',
    body2: 'Puede cerrar esta página.',
    code: 'Código: {code}',
  },
  error: {
    title: 'No podemos procesar su solicitud',
    linkProblemDetailed:
      'El enlace que ha seguido presenta problemas. Verifique que el enlace en la barra de direcciones coincida con el que se le proporcionó e inténtelo de nuevo.',
    linkProblemGeneric:
      'El enlace que ha seguido presenta problemas. Por favor, inténtelo de nuevo.',
    contactPerson:
      'Si el problema persiste, informe de esta incidencia a la persona que le proporcionó el enlace.',
    errorCode: 'Código de error: {code}',
  },
};

export default es;
